const locale = {
  placeholder: 'Välj tid',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/sv_SE.tsx